import React, { Fragment } from 'react';
import classnames from 'classnames';
import { noop, map, isEmpty, get } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { button as Button } from 'modules/button';
import { AuthFlowMemberVerificationMatchCriteriaWidget } from 'ui/containers/AuthFlowMemberVerificationMatchCriteriaWidget';
import { AuthFlowMemberVerificationFamilyUnitWidget } from 'ui/containers/AuthFlowMemberVerificationFamilyUnitWidget';
import { AuthFlowMemberVerificationHipaaAuthorization } from 'ui/containers/AuthFlowMemberVerificationHipaaAuthorization';
import { AuthFlowMemberVerificationMemberSearch } from 'ui/containers/AuthFlowMemberVerificationMemberSearch';
import { AuthFlowVerificationPreVerifiedMembersWidget } from 'ui/containers/AuthFlowVerificationPreVerifiedMembersWidget';
import { WIDGET_NAMES } from 'constants/entity-names';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_MEMBER_PRE_VERIFIED_MEMBERS ]: AuthFlowVerificationPreVerifiedMembersWidget,
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_MEMBER_SEARCH ]: AuthFlowMemberVerificationMemberSearch,
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_MATCH_CRITERIA ]: AuthFlowMemberVerificationMatchCriteriaWidget,
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_FAMILY_UNIT ]: AuthFlowMemberVerificationFamilyUnitWidget,
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_HIPAA_AUTH ]: AuthFlowMemberVerificationHipaaAuthorization,
    [ WIDGET_NAMES.AUTH_FLOW_MEMBER_VERIFICATION_COMM_HISTORY ]: Fragment,
};

/*******************************/

// success view
export const authFlowMemberVerificationStepSuccess = ( props ) => {
    return (
        <div className='ui-auth-flow-member-verification-step'>
            {/* widgets */}
            <div className='ui-auth-flow-member-verification-step__widgets'>
                {
                    map( props.widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        // set widget class name
                        const widgetClassName = classnames( 'ui-auth-flow-member-verification-step__widgets__item', {
                            [ `ui-auth-flow-member-verification-step__widgets__item--${ widget.name }` ]: ! isEmpty( widget.name ),
                        } );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    onMarkVerified={ props.onMarkVerified }
                                    memberId={ props.memberId }
                                    onMemberSelection={ props.onMemberSelection }
                                    patientId= { props.patientId }
                                />
                            </div>
                        );
                    } )
                }
            </div>

            {/* navigation */}
            <div className='ui-auth-flow-member-verification-step__navigation'>
                {
                    map( props.navActions, navAction => {
                        return (
                            <Button
                                key={ navAction.name }
                                className='ui-auth-flow-member-verification-step__navigation__item'
                                size='large'
                                showIcon={ true }
                                disabled={ !get( props, 'processStatus.isMemberVerified', false )}
                                { ...navAction }
                            />
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
authFlowMemberVerificationStepSuccess.displayName = 'authFlowMemberVerificationStepSuccess';

// set default props
authFlowMemberVerificationStepSuccess.defaultProps = {
    widgets: [],
    navActions: [],
    onMemberSelection: noop,
    onMarkVerified: noop,
};

// prop types
authFlowMemberVerificationStepSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowMemberVerificationStepPreloader = () => {
    return (
        <div className='ui-auth-flow-member-verification-step-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
authFlowMemberVerificationStepPreloader.displayName = 'authFlowMemberVerificationStepPreloader';

// set default props
authFlowMemberVerificationStepPreloader.defaultProps = {};

// prop types
authFlowMemberVerificationStepPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowMemberVerificationStep as AuthFlowMemberVerificationStep } from 'ui/views/widgets/authFlowMemberVerificationStep';
 *
 * // render
 * <AuthFlowMemberVerificationStep propName='propValue'/>
 */
export const authFlowMemberVerificationStep = withNetworkState( authFlowMemberVerificationStepPreloader, authFlowMemberVerificationStepSuccess );
